import React from "react";
import { createPortal } from "react-dom";
import "./Tooltip.css";

interface TooltipRef {
    id: number,
    close: () => void,
}
let activeTooltip: TooltipRef | undefined = undefined;

let nextId = 0;

export function useTooltipProps() {
    const timerRef = React.useRef<number | undefined>(undefined);
    const [position, setPosition] = React.useState<[number, number]>();
    const [id] = React.useState(() => nextId++);

    if (position !== undefined) {
        if (activeTooltip && activeTooltip.id !== id)
            setTimeout(activeTooltip.close);
        activeTooltip = { id, close: () => setPosition(undefined) };
    }

    return {
        tooltipContainerProps:
            matchMedia('(pointer:fine)').matches ? {
                onTouchStart: (e: React.TouchEvent) => {
                    const touch = e.touches[0];
                    clearTimeout(timerRef.current);
                    timerRef.current = setTimeout((() => setPosition([touch.clientX, touch.clientY])) as TimerHandler, 100);
                },
                onTouchEnd: () => clearTimeout(timerRef.current),
                onTouchCancel: () => clearTimeout(timerRef.current),
                onMouseMove: (e: React.MouseEvent) => setPosition([e.clientX, e.clientY + 10]),
                onMouseLeave: () => setPosition(undefined),
            } : {},
        tooltipProps: {
            close: () => {
                console.log("I'm being closed");
                setPosition(undefined)
            },
            position
        },
    }
}

export function Tooltip(props: { close: () => void, children: React.ReactNode, position: [number, number] | undefined }) {
    if (!props.position) return <></>
    const { close, children, position: [left, top] } = props;
    return createPortal(<div className="tooltip" style={{ top, left }} >
        <div className="tooltip-close-button" onClick={close} />
        {children}
    </div>, document.getElementById("tooltipContainer")!)
}
